module.exports = __webpack_public_path__ + "static/media/iconThree.63d387a7.svg";